import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Cookie-only auth: the backend issues HttpOnly access/refresh cookies.
// `withCredentials` ensures they are sent on every request. No token is ever
// persisted in JS-accessible storage (localStorage), eliminating XSS token theft.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;
